import React from "react";

// Recreated brand wordmark: bar-chart mark + ACTIVATE (A & I in fuchsia)
// + THEN ELEVATE / AI CONSULTING, matching the gala ad.
export const Logo = ({ variant = "dark", className = "", showTagline = true }) => {
  const isDark = variant === "dark";
  const baseText = isDark ? "#ffffff" : "#0f172a";
  const sub = isDark ? "rgba(255,255,255,0.75)" : "#64748b";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      {/* Bars mark */}
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" aria-hidden="true">
        <rect x="1" y="20" width="5" height="13" rx="2" fill="#E933C6" opacity="0.55" />
        <rect x="9" y="12" width="5" height="21" rx="2" fill="#FF4FD8" opacity="0.8" />
        <rect x="17" y="4" width="5" height="29" rx="2" fill="#E933C6" />
        <rect x="25" y="14" width="5" height="19" rx="2" fill="#8B5CF6" />
      </svg>
      <div className="leading-none">
        <div
          className="font-display font-extrabold tracking-tight text-lg sm:text-xl"
          style={{ color: baseText }}
        >
          <span style={{ color: "#E933C6" }}>A</span>CT
          <span style={{ color: "#E933C6" }}>I</span>VATE
        </div>
        {showTagline && (
          <div className="flex items-center gap-2 mt-0.5">
            <span className="h-[2px] w-6 rounded-full" style={{ background: "linear-gradient(90deg,#E933C6,#8B5CF6)" }} />
            <span
              className="font-mono-accent text-[9px] sm:text-[10px] tracking-[0.28em] uppercase"
              style={{ color: sub }}
            >
              Then Elevate
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Logo;
